/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

import React from 'react';
import { Input } from 'antd';
import { EyeOutlined, EyeInvisibleOutlined, LockOutlined } from '@ant-design/icons';

type State = any;
type Props = any;

class Password extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      visiable: false,
    };
  }

  handleClick = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState((prevState: any) => ({
      visiable: !prevState.visiable,
    }));
  };

  render() {
    const { visiable } = this.state;
    const type = visiable ? 'text' : 'password';
    const suffix = (
      <div onClick={this.handleClick}>{visiable ? <EyeOutlined /> : <EyeInvisibleOutlined />}</div>
    );

    return (
      <Input
        {...this.props}
        placeholder="密码"
        type={type}
        prefix={<LockOutlined />}
        suffix={suffix}
      />
    );
  }
}

export default Password;
